export default __webpack_public_path__ + "static/media/480_business01-fr-web.c97fb800.png";